var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30237 2.22937C1.87605 1.87828 1.24583 1.93927 0.894736 2.36559C0.543645 2.79192 0.604634 3.42214 1.03096 3.77323L2.30237 2.22937ZM24.969 3.77323C25.3954 3.42214 25.4564 2.79192 25.1053 2.36559C24.7542 1.93927 24.124 1.87828 23.6976 2.22937L24.969 3.77323ZM3 2.66797H23V0.667969H3V2.66797ZM24 3.66797V18.3346H26V3.66797H24ZM23 19.3346H3V21.3346H23V19.3346ZM2 18.3346V3.66797H0V18.3346H2ZM1.03096 3.77323L11.0929 12.0595L12.3643 10.5157L2.30237 2.22937L1.03096 3.77323ZM14.9071 12.0595L24.969 3.77323L23.6976 2.22937L13.6357 10.5157L14.9071 12.0595ZM3 19.3346C2.44772 19.3346 2 18.8869 2 18.3346H0C0 19.9915 1.34315 21.3346 3 21.3346V19.3346ZM24 18.3346C24 18.8869 23.5523 19.3346 23 19.3346V21.3346C24.6569 21.3346 26 19.9915 26 18.3346H24ZM23 2.66797C23.5523 2.66797 24 3.11568 24 3.66797H26C26 2.01111 24.6569 0.667969 23 0.667969V2.66797ZM11.0929 12.0595C12.2006 12.9718 13.7994 12.9718 14.9071 12.0595L13.6357 10.5157C13.2665 10.8198 12.7335 10.8198 12.3643 10.5157L11.0929 12.0595ZM3 0.667969C1.34315 0.667969 0 2.01111 0 3.66797H2C2 3.11568 2.44771 2.66797 3 2.66797V0.667969Z",
    fill: "#C32B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.72666ba7fe4d60baee85e5a6086ca0d5.svg";
export { ForwardRef as ReactComponent };